import { REPORT_TYPE_MARRIED, userReportsProfile } from "../../../services/report";
import useAuth from "../../hooks/useAuth";
import { ToastContainer, toast } from "react-toastify";
import { Modal, Button, TextField, Typography, Box } from '@mui/material';
import React from "react";
import { modalStyle } from "../../home/Homepage";


export const ReportButton = ({profileId}) => {
    const {
        reportedUsers, 
        addReportsToState,
        getToken
	} = useAuth();
	const isUserReported = reportedUsers.findIndex((report) => report === profileId) !== -1;
    const [comment, setComment] = React.useState('');
    const [isModalOpen, setIsModalOpen] = React.useState(false);

    const reportUser = () => {
        var report = {
            id: profileId,
            comment: comment,
            type: REPORT_TYPE_MARRIED
        }
        toast.info("Reporting profile, please wait..")
        setIsModalOpen(false)
        userReportsProfile(getToken()?.token, report)
            .then((reportProfileResponse) => {
                if (reportProfileResponse.errors) {
                    toast.error('Failed to report User, please retry after sometime');                    
                    console.error(
                        'failure response from reporting profile endpoint',
                        reportProfileResponse.errors
                    );
                } else {
                    addReportsToState([report.id])
                    toast.success('User reported successfully');
                    setComment('')
                }
            }).catch(err => {
                    toast.error('There was an unexpected error, please try again after sometime');                    
                                        
                    console.error(
                        'failure in reporting profile',
                        err
                    );
            });
    }

    return <>
    
        <ToastContainer autoClose={3000} />
        <Modal
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            aria-labelledby="Confirm reporting user modal"
        >
            <Box sx={modalStyle}>
								
                <Typography id="modal-title" variant="h6" component="h2">
                    Are you sure you want to report this profile as married?
                </Typography>
                <TextField
                    id="comment"
                    label="Additional Comment"
                    fullWidth
                    multiline
                    value={comment}
                    onChange={event => setComment(event.target.value)}
                    variant="outlined"
                    margin="normal"
                />
                <Box 
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end', // This will space out your buttons evenly
                        marginTop: 2, // This adds space between the text field and the buttons
                    }}
                >
                    <Button variant="contained" sx={{mr: 2}} onClick={reportUser}>Yes</Button>
                    <Button variant="outlined" onClick={()=>setIsModalOpen(false)}>No</Button>
                </Box>
            </Box>
        </Modal>
        <button
            disabled={isUserReported}
            className="btn btn-info text-white w-full sm:w-fit"
            onClick={() =>setIsModalOpen(true)}
        >
            {isUserReported? 'Profile Reported':'Report as Married'}
        </button>
    </>
}